import appGlobalScript from '/home/github-action-runners/ac_charts_runner_1/_work/arcgis-charts/arcgis-charts/node_modules/@esri/calcite-components/dist/collection/utils/globalScript.js';
export const globalScripts = appGlobalScript;
